var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoNoTitle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 12,
    viewBox: "0 0 36 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6768 10.9885H0L6.37022 0L12.6768 10.9885Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4692 0.75642C21.3293 1.26075 22.0112 1.94273 22.5155 2.80283C23.0198 3.66262 23.2719 4.59716 23.2719 5.60567C23.2719 6.61433 23.0198 7.54606 22.5155 8.40053C22.0112 9.25531 21.3293 9.93213 20.4692 10.431C19.6091 10.9302 18.6748 11.1794 17.6663 11.1794C16.6576 11.1794 15.7259 10.9302 14.8715 10.431C14.0166 9.93213 13.3399 9.25531 12.8409 8.40053C12.3416 7.54606 12.0923 6.61433 12.0923 5.60567C12.0923 4.59716 12.3416 3.66262 12.8409 2.80283C13.3399 1.94273 14.0166 1.26075 14.8715 0.75642C15.7259 0.252244 16.6576 0 17.6663 0C18.6748 0 19.6091 0.252244 20.4692 0.75642Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6655 10.9885H35.4787V0.175171H24.6655V10.9885Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoTitle);
export default __webpack_public_path__ + "static/media/logo_no_title.a2b95af63c9583ebd0e0ebae8620eadf.svg";
export { ForwardRef as ReactComponent };